/**
 * 캘린더 테마 카탈로그 client — 8443 edge 가 `/calendar-themes-config` → admin BFF(:3100) 로 프록시
 * (menu-config 동형, 무인증 공개 reader). enabled 테마만 반환.
 */
// eslint-disable-next-line no-restricted-imports
import axios from 'axios';

export interface CalendarThemeDto {
  theme_key: string;
  name: string;
  description: string | null;
  tokens: Record<string, string>;
  sort_order: number;
}
export interface CalendarThemesConfig {
  themes: CalendarThemeDto[];
  version: number;
}

const client = axios.create({ baseURL: '/', withCredentials: true, timeout: 8000 });

export async function getCalendarThemesConfig(): Promise<CalendarThemesConfig> {
  const { data } = await client.get<CalendarThemesConfig>('/calendar-themes-config');
  return { themes: Array.isArray(data?.themes) ? data.themes : [], version: data?.version ?? 0 };
}
